<template>
  <div>
    <RightPanelTemplate
      v-if="openSectionVariants && mjmlStore.selectedSection"
      id="sectionVariantsPanel"
      :header="$t('variants.variants')"
      :help="helpdeskStore.helpdesk.variants"
      :close-outside="false"
      @close="closeSectionVariants"
    >
      <template #headerIcon>
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M9.12109 1.46094C9.40234 1.32031 9.68359 1.25 10 1.25C10.2812 1.25 10.5625 1.32031 10.8438 1.46094L18.2266 4.58984C18.6836 4.80078 19 5.25781 19 5.75C19 6.27734 18.6836 6.73438 18.2266 6.94531L10.8438 10.0742C10.5625 10.2148 10.2812 10.25 10 10.25C9.68359 10.25 9.40234 10.2148 9.12109 10.0742L1.73828 6.94531C1.28125 6.73438 1 6.27734 1 5.75C1 5.25781 1.28125 4.80078 1.73828 4.58984L9.12109 1.46094ZM10 2.9375C9.89453 2.9375 9.82422 2.97266 9.78906 3.00781L3.32031 5.75L9.78906 8.52734C9.82422 8.5625 9.89453 8.5625 10 8.5625C10.0703 8.5625 10.1406 8.5625 10.1758 8.52734L16.6445 5.75L10.1758 3.00781C10.1406 2.97266 10.0703 2.9375 10 2.9375ZM9.78906 13.0273C9.82422 13.0625 9.89453 13.0625 10 13.0625C10.0703 13.0625 10.1406 13.0625 10.1758 13.0273L16.8906 10.1797C16.7148 9.93359 16.6797 9.61719 16.8203 9.33594C17.0312 8.91406 17.5234 8.73828 17.9453 8.94922L18.2617 9.125C18.7188 9.33594 19 9.75781 19 10.25C19 10.7773 18.6836 11.2344 18.1914 11.4453L10.8438 14.5742C10.5625 14.7148 10.2812 14.75 10 14.75C9.68359 14.75 9.40234 14.7148 9.12109 14.5742L1.77344 11.4453C1.28125 11.2344 1 10.7773 1 10.2148C1 9.79297 1.17578 9.40625 1.52734 9.16016L1.91406 8.87891C2.26562 8.63281 2.79297 8.70312 3.07422 9.08984C3.32031 9.40625 3.28516 9.86328 3.00391 10.1445L9.78906 13.0273ZM3.07422 13.5898C3.32031 13.9062 3.28516 14.3633 3.00391 14.6445L9.78906 17.5273C9.82422 17.5625 9.89453 17.5625 10 17.5625C10.0703 17.5625 10.1406 17.5625 10.1758 17.5273L16.8906 14.6797C16.7148 14.4336 16.6797 14.1172 16.8203 13.8359C17.0312 13.4141 17.5234 13.2383 17.9453 13.4492L18.2617 13.625C18.7188 13.8359 19 14.2578 19 14.75C19 15.2773 18.6836 15.7344 18.1914 15.9453L10.8438 19.0742C10.5625 19.2148 10.2812 19.25 10 19.25C9.68359 19.25 9.40234 19.2148 9.12109 19.0742L1.77344 15.9453C1.28125 15.7344 1 15.2773 1 14.7148C1 14.293 1.17578 13.9062 1.52734 13.6602L1.91406 13.3789C2.26562 13.1328 2.79297 13.2031 3.07422 13.5898Z"
            fill="url(#paint0_linear_4416_548)"
          />
          <defs>
            <linearGradient
              id="paint0_linear_4416_548"
              x1="10"
              y1="4"
              x2="10"
              y2="16"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#BFADFF" />
              <stop offset="1" stop-color="#7853FF" />
            </linearGradient>
          </defs>
        </svg>
      </template>
      <div>
        <SectionVariants />
      </div>
    </RightPanelTemplate>
    <RightPanelTemplate
      v-else-if="chatAIStore.chatAiIsEnable && openChatAI"
      id="chatPanel"
      :header="$t('layout.chatAI.header')"
      width="400px"
      @close="closeChatAi"
      @dragging="minChat"
    >
      <template #headerIcon>
        <AIIcon />
      </template>
      <div>
        <ChatAI />
      </div>
    </RightPanelTemplate>
    <RightPanelTemplate
      v-else-if="autosavesStore.autosavesEnabled && openAutosaves"
      id="historyPanel"
      :header="$t('layout.history')"
      :draggable="false"
      @close="closeHistory"
    >
      <template #headerIcon>
        <svg
          width="20"
          height="20"
          viewBox="0 0 512 512"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M75 75L41 41C25.9 25.9 0 36.6 0 57.9V168c0 13.3 10.7 24 24 24H134.1c21.4 0 32.1-25.9 17-41l-30.8-30.8C155 85.5 203 64 256 64c106 0 192 86 192 192s-86 192-192 192c-40.8 0-78.6-12.7-109.7-34.4c-14.5-10.1-34.4-6.6-44.6 7.9s-6.6 34.4 7.9 44.6C151.2 495 201.7 512 256 512c141.4 0 256-114.6 256-256S397.4 0 256 0C185.3 0 121.3 28.7 75 75zm181 53c-13.3 0-24 10.7-24 24V256c0 6.4 2.5 12.5 7 17l72 72c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-65-65V152c0-13.3-10.7-24-24-24z"
            fill="url(#paint01_linear_4416_548)"
          />
          <defs>
            <linearGradient
              id="paint01_linear_4416_548"
              gradientTransform="rotate(90)"
            >
              <stop stop-color="#BFADFF" />
              <stop offset="1" stop-color="#7853FF" />
            </linearGradient>
          </defs>
        </svg>
      </template>
      <div>
        <autosaves></autosaves>
      </div>
    </RightPanelTemplate>
    <RightPanelTemplate
      v-else-if="commentsStore.enableComments && openComments"
      id="commentsPanel"
      @close="closeComments"
      @dragging="minComments"
    >
      <div>
        <Comments />
      </div>
    </RightPanelTemplate>
  </div>
</template>

<script setup lang="ts">
  import RightPanelTemplate from "./_internal/RightPanelTemplate.vue";

  import { useMjmlStore } from "@/stores/mjmlStore";
  import { useNotificationsStore } from "@/stores/notifications";
  import { useSectionVariantsStore } from "@/stores/sectionVariantsStore";
  import { useAutosavesStore } from "@/stores/autosaves";
  import { useChatAI } from "@/stores/chatAIStore";
  import { useCommentsStore } from "@/stores/commentsStore";
  import { useHelpdeskStore } from "@/stores/helpdeskStore";

  import { AIIcon } from "@topol/icons";

  import {
    computed,
    ref,
    watch,
    onMounted,
    onUnmounted,
    defineAsyncComponent,
  } from "vue";

  const SectionVariants = defineAsyncComponent(
    () => import("@/forms/components/SectionVariants/SectionVariants.vue")
  );
  const Autosaves = defineAsyncComponent(
    () => import("@/layout/Autosaves/Autosaves.vue")
  );
  const ChatAI = defineAsyncComponent(
    () => import("@/layout/RightPanel/ChatAI/ChatAI.vue")
  );
  const Comments = defineAsyncComponent(
    () => import("@/layout/RightPanel/Comments/Comments.vue")
  );

  const mjmlStore = useMjmlStore();
  const notificationsStore = useNotificationsStore();
  const sectionVariantsStore = useSectionVariantsStore();
  const autosavesStore = useAutosavesStore();
  const chatAIStore = useChatAI();
  const commentsStore = useCommentsStore();
  const helpdeskStore = useHelpdeskStore();

  const panelIsOpen = ref(false);

  const tryOpenAutosaves = computed(() => {
    return autosavesStore.autosaveMenuOpen;
  });

  const tryOpenChatAI = computed(() => {
    return chatAIStore.isOpenedChat;
  });

  const tryOpenSectionVariants = computed(() => {
    return sectionVariantsStore.openVariantPanel;
  });

  const tryOpenComments = computed(() => {
    return commentsStore.commentsOpen;
  });

  const openAutosaves = ref(tryOpenAutosaves.value);
  const openChatAI = ref(tryOpenChatAI.value);
  const openSectionVariants = ref(tryOpenSectionVariants.value);
  const openComments = ref(tryOpenComments.value);

  function closeSectionVariants() {
    sectionVariantsStore.openVariantPanel = false;
  }

  function closeChatAi() {
    chatAIStore.closeChat();
  }

  function minChat(val: boolean) {
    chatAIStore.isNotAtHome = val;
  }

  function minComments(val: boolean) {
    commentsStore.isNotAtHome = val;
  }

  function closeHistory() {
    autosavesStore.autosaveMenuOpen = false;
  }

  function closeComments() {
    commentsStore.commentsOpen = false;
    commentsStore.openDetail = false;
  }

  watch(
    [tryOpenAutosaves, tryOpenChatAI, tryOpenSectionVariants, tryOpenComments],
    (newVal, oldVal) => {
      if (!panelIsOpen.value) {
        if (newVal[0]) {
          openAutosaves.value = true;
          panelIsOpen.value = true;
        }
        if (newVal[1]) {
          openChatAI.value = true;
          panelIsOpen.value = true;
        }
        if (newVal[2]) {
          openSectionVariants.value = true;
          panelIsOpen.value = true;
        }
        if (newVal[3]) {
          openComments.value = true;
          panelIsOpen.value = true;
        }
      } else {
        if (newVal[0] !== oldVal[0]) {
          if (newVal[0]) {
            autosavesStore.autosaveMenuOpen = false;
            notificationsStore.createNotification({
              type: "error",
              text: `First you have to close ${
                oldVal.indexOf(true) === 1 ? "Chat AI" : "Section variants"
              }.`,
            });
          } else if (openAutosaves.value) {
            openAutosaves.value = false;
            panelIsOpen.value = false;
          }
        }
        if (newVal[1] !== oldVal[1]) {
          if (newVal[1]) {
            chatAIStore.closeChat();
            notificationsStore.createNotification({
              type: "error",
              text: `First you have to close ${
                oldVal.indexOf(true) === 0 ? "Save history" : "Section variants"
              }.`,
            });
          } else if (openChatAI.value) {
            openChatAI.value = false;
            panelIsOpen.value = false;
          }
        }
        if (newVal[2] !== oldVal[2]) {
          if (newVal[2]) {
            sectionVariantsStore.openVariantPanel = false;
            notificationsStore.createNotification({
              type: "error",
              text: `First you have to close ${
                oldVal.indexOf(true) === 1 ? "Chat AI" : "Save history"
              }.`,
            });
          } else if (openSectionVariants.value) {
            openSectionVariants.value = false;
            panelIsOpen.value = false;
          }
        }
        if (newVal[3] !== oldVal[3]) {
          if (newVal[3]) {
            commentsStore.commentsOpen = false;
            notificationsStore.createNotification({
              type: "error",
              text: `First you have to close ${
                oldVal.indexOf(true) === 1 ? "Chat AI" : "Save history"
              }.`,
            });
          } else if (openComments.value) {
            openComments.value = false;
            panelIsOpen.value = false;
          }
        }
      }
    }
  );

  onMounted(() => {
    autosavesStore.setIntervalToAutosave();
    commentsStore.startLoadingCommnets();
    if (
      openAutosaves.value ||
      openChatAI.value ||
      openSectionVariants.value ||
      openComments.value
    )
      panelIsOpen.value = true;
  });

  onUnmounted(() => {
    autosavesStore.clearIntervalToAutosave();
    commentsStore.clearIntervalToComments();
    panelIsOpen.value = false;
    chatAIStore.isNotAtHome = false;
    commentsStore.isNotAtHome = false;
  });
</script>
